module.exports = __webpack_public_path__ + "assets/img/alert.67e0f018.svg";